import { render } from "./DeleteData.vue?vue&type=template&id=28d87e1a&scoped=true"
import script from "./DeleteData.vue?vue&type=script&lang=js"
export * from "./DeleteData.vue?vue&type=script&lang=js"

import "./DeleteData.vue?vue&type=style&index=0&id=28d87e1a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d87e1a"]])

export default __exports__